import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TenantFiscal } from 'src/app/models/tenant-fiscal.model';
import { Tenant } from 'src/app/models/tenant.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { RFCValidator } from 'src/app/shared/validators/rfc';

@Component({
  selector: 'app-form-tenant-fiscal',
  template: `
    <form [formGroup]="userFiscalForm" (ngSubmit)="updateFiscal()">
      <!-- legend class="mt-3 mb-4" style="font-size: 19px; font-weight: 800;">Datos fiscales</!-->
      <div class="form-group mt-3">
        <label for="rfc" class="form-control-label text-sm">RFC</label>
        <input type="text" appRfcValidator [isComercial]="isComercial" [maxlength]="13" [allowBoth]="true" class="form-control" id="rfc" formControlName="rfc">
        <div *ngIf="ffc['rfc']?.touched && ffc['rfc']?.invalid">
          <div *ngIf="ffc['rfc']?.errors?.['rfcInvalid']" class="text-danger text-sm">El RFC es inválido.</div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="razon_social" class="form-control-label text-sm">Razón social</label>
        <input type="text" class="form-control" id="razon_social" formControlName="razon_social">
        <div *ngIf="ffc['razon_social']?.touched && ffc['razon_social']?.invalid">
          <div *ngIf="ffc['razon_social']?.errors?.['required']" class="text-danger text-sm">La razón social es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="zip_code" class="form-control-label text-sm">Código postal</label>
        <input type="text" class="form-control" id="zip_code" formControlName="zip_code">
        <div *ngIf="ffc['zip_code']?.touched && ffc['zip_code']?.invalid">
          <div *ngIf="ffc['zip_code']?.errors?.['required']" class="text-danger text-sm">El Código postal es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3" *ngIf="catalogs?.regimenes?.length>0">
        <label for="regimen_fiscal" class="form-control-label text-sm">Regímen fiscal</label>
        <select class="form-select" formControlName="regimen_fiscal">
          <option value="" selected>Selecciona un régimen fiscal</option>
          <option *ngFor="let regimen of catalogs?.regimenes" [value]="regimen?.id" [selected]="regimen?.id == ffc['regimen_fiscal'].value">{{regimen?.id}} - {{regimen?.name}}</option>
        </select>
        <div *ngIf="ffc['regimen_fiscal']?.touched && ffc['regimen_fiscal']?.invalid">
          <div *ngIf="ffc['regimen_fiscal']?.errors?.['required']" class="text-danger text-sm">El Regimen fiscal es requerido.</div>
        </div>
      </div>
      <div class="form-group mt-3" *ngIf="catalogs?.usosCFDI?.length>0">
        <label for="uso_cfdi" class="form-control-label text-sm">Uso CFDI</label>
        <select class="form-select" formControlName="uso_cfdi">
          <option value="" selected>Selecciona un uso de CFDI</option>
          <option *ngFor="let usoCFDI of catalogs?.usosCFDI" [value]="usoCFDI?.id">{{usoCFDI.id}} - {{usoCFDI.name}}</option>
        </select>
        <div *ngIf="ffc['uso_cfdi']?.touched && ffc['uso_cfdi']?.invalid">
          <div *ngIf="ffc['uso_cfdi']?.errors?.['required']" class="text-danger text-sm">El Uso de CFDI es requerido.</div>
        </div>
      </div>

      <div class="form-group mt-5 mb-2 text-end">
        <button type="submit" class="btn btn-zazz-dark">
          <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="loading" class="ms-2 "></fa-icon>
          <fa-icon [icon]="icons.faSave" *ngIf="!loading" class="me-2"></fa-icon>
          Guardar
        </button>
      </div>
    </form>
  `,
  styleUrls: []
})
export class FormTenantFiscalComponent implements OnInit {
  @Input() catalogs: any;
  @Input() fiscal: TenantFiscal | null = null;
  @Input() tenant: Tenant | null = null;
  @Output() save: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  userFiscalForm: FormGroup = new FormGroup({});
  isComercial!: boolean;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private store: SettlementsService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.isComercial = sessionStorage.getItem('tenantType') === 'comercial' ? true : false;
    this.initForm(); 
  }
  
  ngOnInit(): void {    
  }

  ngAfterViewInit(): void {    
    if (this.tenant) {
      this.tenant.tenant_fiscal && this.loadFiscal(this.tenant!.tenant_fiscal!);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tenant'] && changes['tenant'].currentValue && changes['tenant'].currentValue.tenant_fiscal) {
      const tenant_fiscal = changes['tenant'].currentValue.tenant_fiscal;
      tenant_fiscal && this.loadFiscal(tenant_fiscal);
    }
  }

  loadFiscal(tenant_fiscal: TenantFiscal) {
    this.loading = true;
    this.userFiscalForm.patchValue({
      id: tenant_fiscal.id,
      periodic: tenant_fiscal.periodic,
      rfc: tenant_fiscal.rfc,
      razon_social: tenant_fiscal.razon_social,
      zip_code: tenant_fiscal.zip_code,
      regimen_fiscal: tenant_fiscal.regimen_fiscal,
      uso_cfdi: tenant_fiscal.uso_cfdi,
      tenant_id: tenant_fiscal.tenant_id
    });
    this.loading = false;
  }

  initForm() {
    console.log('initForm TENANT FISCAL');
    this.userFiscalForm = this.fb.group({
      id: [],
      rfc: ['', [RFCValidator(this.isComercial,true)]],
      razon_social: [''],
      zip_code: [''],
      regimen_fiscal: [''],
      uso_cfdi: [''],
      tenant_id: []
    });
  }

  get ffc() {
    return this.userFiscalForm.controls;
  }

  updateFiscal() {
    this.loading = true;
    if (this.userFiscalForm.invalid) {
      this.toastr.error('No está completa la información.', 'Error');
      this.userFiscalForm.markAllAsTouched();
      return;
    }

    this.save.emit(this.userFiscalForm.value);
    this.loading = false;
  }

}
